
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { ENV_CONSTANTS } from '@env-properties/environment';

export class DownloadImplementation{
    globalService: any;
    router: any;
    http: any;
    downloadError: boolean;
    downloadLimitReached: boolean = false;
    public downloadInitialized:boolean = false; 
    loggerService: any;
    commonService:any;
    universalService: any;
    minStatusInterval:any = 0;
    maxWaitInterval:any = 0;
    static singleInstance:DownloadImplementation;
    cleverTapEventsService: any;
    localStorageService:any;
    constructor(globalService){
        this.globalService=globalService;
    }

    public static getInstance(globalService):DownloadImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new DownloadImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

    setHandler(globalService){
        this.universalService=globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.cleverTapEventsService = globalService.getCleverTapEventsvc();
        this.http=globalService.getHttpClientRef();
        this.localStorageService = globalService.getLocalStorageSvcRef();
    }
    initiateZipDownload(url,temp, retry){
        let objects = temp["items"];
        this.universalService.downloadInProgress = true;
        var self = this;
        var params = {};
        if(window.location.href.includes('/teamfolder') || this.universalService.searchType == 'teamfolder') {//BDL for TF
            params = objects;
        } else {
            params = {
                "objects":objects
            }
        }
        let curr_item;
        self.universalService.downloadQueue.forEach(e => {
            if(e.key == temp.key){
                curr_item = e;
            }
        });
        self.http.post(url,params , {observe: 'response'}).subscribe(
            async resp=>{
                //Get min and max interval to wait (in seconds)
                if(resp.headers.get('X-Status-Interval-Min-Sec')) {
                    self.minStatusInterval = (resp.headers.get('X-Status-Interval-Min-Sec')) * 1000;
                }
                if(resp.headers.get('X-Total-Wait-Max-Sec')) {
                    self.maxWaitInterval = (resp.headers.get('X-Total-Wait-Max-Sec')) * 1000;
                }
                if(resp.body.isZipReady == false){
                    self.downloadInitialized = true;
                    self.downloadPing(resp.body.bdlURL,temp);
                    self.downloadError = false;
                }
            },
            err=>{
                console.log("error in zip download initiation",err);
                if(err.status == 429){
                    self.downloadLimitReached = true;
                    curr_item.statusText = "Too Many Requests";
                    $("#expand_btn_dwn").click()
                    self.universalService.removeDownloadItemFromList(curr_item)
                }
                else if(err.status == 413 && err.error.code == "TEJDL4130"){
                    curr_item.statusText = "Download Failed";
                    $("#expand_btn_dwn").click()
                    self.universalService.removeDownloadItemFromList(curr_item)
                    setTimeout(()=>{
                        self.universalService.showToast(TOAST["DOWNLOAD_SIZE_ERROR"],"error");
                    },500)
                }
                else if(retry>1){
                    retry--;
                    self.initiateZipDownload(url, temp, retry);
                }
                else{
                    curr_item.statusText = "Download Failed";
                    $("#expand_btn_dwn").click()
                    self.universalService.removeDownloadItemFromList(curr_item)
                }
            }
        )
    }

    public downloadPing(url, temp){
        let objects = temp["items"];
        var self = this;
        let defaultPingTime = 2000;
        let pingTime = (self.minStatusInterval == 0 ? defaultPingTime : self.minStatusInterval);
        let maxWait = self.maxWaitInterval;
        let curr_item;
        let retry = ENV_CONSTANTS["constants"]["maxRetryLimitForBulkDownload"];
        self.universalService.downloadQueue.forEach(e => {
            if(e.key == temp.key){
                curr_item = e;
            }
        });
        let tryTime = 1;
        let pingcall = setInterval(callback,pingTime)
        function callback(){
            if(!url.includes('try')) url += (url.includes('?')?'&':'?') + 'try=' + tryTime
            else{
                let mainUrl = url.split('try=')[0];
                tryTime += 1;
                url = mainUrl + 'try=' + tryTime
            }
            clearInterval(pingcall);
            if(curr_item.cancelDownload){
                return;
            }
            self.http.get(url).subscribe(
                async resp=>{
                    if(resp.isZipReady == true){
                        self.downloadInitialized = false;
                        curr_item.statusText = "Your download has started";
                        await self.downloadAllFilesAsZip(resp.bdlURL,curr_item);
                        self.downloadError = false;
                    }
                    else{
                        if(pingTime < maxWait) pingTime *= 2;
                        pingcall = setInterval(callback, pingTime);
                    }
                },
                err=>{
                        console.log("error in download ping",err);
                        retry--;
                        if(retry==0){
                            curr_item.statusText = "Download Failed";
                            $("#expand_btn_dwn").click()
                            self.universalService.removeDownloadItemFromList(curr_item)
                        }
                        else{
                            pingcall = setInterval(callback, pingTime);
                        }
                    }
            )
        }
    }

    public downloadAllFilesAsZip(url, item){
        url = url.includes('?') ? url + '&': url + '?';
        url = url + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
        var iframe = document.createElement('iframe')
        iframe.setAttribute("src", url);
        iframe.setAttribute("style", "visibility:hidden;display:none")
        iframe.setAttribute("target", "_blank");
        document.body.appendChild(iframe);
        iframe.click();
        setTimeout(()=>{iframe.remove()},60000);
        $("#expand_btn_dwn").click()
        this.universalService.removeDownloadItemFromList(item);
        this.cleverTapEventsService.fileDownloadSuc(this.universalService.currentTab);
    }

    download(objects,showDownloadAnimation){ //showDownloadAnimation value is used to show download started animation (which will not be used when user tries to download from transfer history screen)
        var singleFileDownloadUrl;
        objects.map(async object=>{
            this.loggerService.log("object",object)
            var url = object["url"]?object["url"]:object["downloadUrl"]
            this.loggerService.log("single download url ==>>",singleFileDownloadUrl)
            var downloadAnchorElem = document.getElementById("downloadAnchor");
            var iframe = document.createElement("iframe");
            iframe.setAttribute("src", singleFileDownloadUrl);
            iframe.setAttribute("style", "visibility:hidden;display:none")
            iframe.setAttribute("target", "_blank");
            downloadAnchorElem.appendChild(iframe);
            downloadAnchorElem.setAttribute("target", "_blank");
            downloadAnchorElem.click();
            this.downloadInitialized = false;
            if(showDownloadAnimation){
                this.commonService.setDataForLottieAnimations('download')
            }
        })
    }
}